import dayjs from 'dayjs';
import { JwtPayload, jwtDecode } from 'jwt-decode';
import { secureStorage } from 'utils/secureStorage';
declare module 'jwt-decode' {
  export interface JwtPayload {
    'custom:orgId': string;
      'custom:root'?: string;
      'cognito:username': string;
      'username': string;
  }
}

export default class AuthUtil {
  static clearStorage() {
    localStorage.removeItem('phx-currentUserName');
    localStorage.removeItem('phx-currentOrganizationName');
    localStorage.removeItem('phx-currentOrganizationId');
    localStorage.removeItem('phx-userOrgId');
    localStorage.removeItem('phx-userpoolConfig');
    localStorage.removeItem('phx-username');
    localStorage.removeItem('phx-currentProfile');
    localStorage.removeItem('phx-appPermissions');
    localStorage.removeItem('phx-orgPermissions');
    localStorage.removeItem('phx-userPermissions');
    localStorage.removeItem('phx-manualPermissions');
    localStorage.removeItem('phx-isRoot');
    localStorage.removeItem('phx-orgRiskPoolStatus');
    secureStorage.removeItem('lexat');
    secureStorage.removeItem('step-up');
  }

  static setSignOutCookie() {
    const expires = new Date();
    expires.setTime(expires.getTime() + 30 * 1000); // 30 seconds
    document.cookie = `isSignOut=true; expires=${expires.toUTCString()}; path=/`;
  }

  static isSignOutInProgress(): boolean {
    return document.cookie.includes('isSignOut=true');
  }

  static clearSignOutCookie() {
    document.cookie = 'isSignOut=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  }

  static shouldAllowStorageOperations(): boolean {
    return !this.isSignOutInProgress();
  }

  static getToken() {
    const token = secureStorage.getItem('lexat');
    return this.validateToken(token) ? token : '';
  }

  static isTokenExpired() {
    const token = this.getToken();
    if (token) {
      const tokenPayload: JwtPayload = jwtDecode(token);
      const isExpired = !!(tokenPayload.exp && tokenPayload.exp < Date.now() / 1000);
      return isExpired;
    }
    return true;
  }

  static isRoot() {
    const token = this.getToken();
    if (!token) return false;
    const tokenPayload: JwtPayload = jwtDecode(token);
    return tokenPayload['custom:root'] !== undefined;
  }

  static validateToken(token: string | null): boolean {
    if (!token) return false;
    try {
      const tokenPayload: JwtPayload = jwtDecode(token);
      const storedUsername = localStorage.getItem('phx-currentUserName');
      return tokenPayload['username'] === storedUsername;
    } catch (error) {
      return false;
    }
  }
}
